import React, { createContext, useContext, useState } from 'react';
import NotificationSnackbar from '../components/Notification/Snackbar';

const NotificationContext = createContext();

export function NotificationProvider({ children }) {
  const [notification, setNotification] = useState({
    open: false,
    message: '',
    severity: 'info', // 'error' | 'warning' | 'info' | 'success'
  });

  const showNotification = (message, severity = 'info') => {
    setNotification({
      open: true,
      message,
      severity,
    });
  };

  const hideNotification = () => {
    setNotification({
      ...notification,
      open: false,
    });
  };

  return (
    <NotificationContext.Provider value={{ showNotification }}>
      {children}
      <NotificationSnackbar
        open={notification.open}
        handleClose={hideNotification}
        severity={notification.severity}
        message={notification.message}
      />
    </NotificationContext.Provider>
  );
}

export const useNotification = () => useContext(NotificationContext); 